import type { ContextState } from "./types";

export const defaultState: ContextState = {
  isAuthError: false,
  isChatConnectError: false,

  isGetMessagesPending: false,
  isGetMessagesLoading: false,
  isGetMessagesSuccess: false,

  isPrevMessagesPending: false,
  isPrevMessagesLoading: false,
  isPrevMessagesSuccess: false,

  isNextMessagesPending: false,
  isNextMessagesLoading: false,
  isNextMessagesSuccess: false,

  isGetMessagesByReplyLoading: false,
  isGetMessagesByReplySuccess: false,

  isMessageSending: false,
  isPostChatInfoLoading: false,
  isPostChatInfoError: false,
};
